export default __webpack_public_path__ + "static/media/img3.9e274c99.png";